export default __webpack_public_path__ + "static/media/video-poster.02a96d86.png";